module.exports = __webpack_public_path__ + "img/otp.8f51fc6b.png";